import { saveAs } from "file-saver";
import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../../Services/Utils";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {
  ACTIVITY_TYPE,
  HttpStatus,
  INITIAL_PAGINATION,
} from "../../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../../common/mapper";
import FakturJualBengkelDetail from "../components/fakturJualBengkelDetail";
import FakturJualBengkelSearch from "../components/fakturJualBengkelSearch";
import { INITIAL_SEARCH_DATA_NOS } from "../constant";
import { getTableConfigNOS } from "./config";
import FakturJualBengkelNosFilter from "./fakturJualBengkelNOSFilter";
import SimpleModal from "../../../../modules/popup/SimpleModal";

class FakturJualBengkelNOS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filterVisible: false,
      detailVisible: false,
      printPreviewVisible: false,
      selectedData: null,
      selectedIndex: null,
      kodeCabang: null,
      submittedFilterData: null,
      searchData: INITIAL_SEARCH_DATA_NOS,
      skipNextPaginationFetch: false,
      PDF: null,
      cabangOptions: [],
      dataTable: [],
      pagination: INITIAL_PAGINATION,
      changeCabang: false,
      printVisible: false,
      userAccess: null,
      skipNextFetch: false,
      activityType: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.state.kodeCabang?.value;
    const prevCabang = prevState.kodeCabang?.value;

    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;

    if (currCabang !== prevCabang) {
      this.setState((prev) => ({
        ...prev,
        searchData: INITIAL_SEARCH_DATA_NOS,
        submittedFilterData: null,
        pagination: INITIAL_PAGINATION,
        skipNextFetch: true,
      }));
      this.fetchDataMainPage(INITIAL_SEARCH_DATA_NOS, 5, 1);
    }

    if (
      (currPagination.page !== prevPagination.page ||
        currPagination.limit !== prevPagination.limit) &&
      !this.state.skipNextFetch
    ) {
      const { dropdownType, keyword, ...rest } = this.state.searchData;
      let filter = {
        ...rest,
        ...(dropdownType && keyword ? { [dropdownType.value]: keyword } : {}),
      };
      if (this.state.submittedFilterData) {
        const {
          namaVarian,
          namaWarna,
          kodeVarian,
          kodeWarna,
          status,
          ...restFilter
        } = this.state.submittedFilterData;
        filter = {
          ...restFilter,
          ...(kodeVarian ? { kodeVarian: kodeVarian?.value } : {}),
          ...(kodeWarna ? { kodeWarna: kodeWarna?.value } : {}),
          ...(status ? { status: status?.value } : {}),
        };
      }
      this.fetchDataMainPage(
        removeNullFields({ ...filter }),
        currPagination.limit,
        currPagination.page
      );
    }

    if (this.state.skipNextFetch) {
      this.setState({
        skipNextFetch: false,
      });
    }
  }

  fetchDataMainPage = async (filter = {}, limit, page) => {
    const { setError } = this.props;
    const { kodeCabang } = this.state;
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getFJBNOSMainPage,
      menuName: "Faktur Jual Bengkel - NOS",
      setError: setError,
      args: {
        ...filter,
        kodeCabang: kodeCabang?.value,
        limit: limit,
        page: page,
      },
    });
    this.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  loadData = async () => {
    const { setError, menuAccess } = this.props;
    const { searchData } = this.state;

    this.handleTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: setError,
      menuName: "Sales Order - Faktur Jual",
      args: {},
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const filteredData = res.data.data.filter((item) =>
        menuAccess.map((data) => data.idRefObj).includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          cabangOptions: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          ),
          kodeCabang: mapToObjectDDL(
            filteredData[0].namaDealer,
            filteredData[0].kodeCabang
          ),
          userAccess: getUserAccess(menuAccess, filteredData[0].kodeCabang),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleSearchKeyword = async () => {
    const { searchData } = this.state;
    this.setState(
      (prev) => ({
        ...prev,
        pagination: INITIAL_PAGINATION,
        skipNextFetch: true,
        searchData: {
          ...prev.searchData,
          startTanggalFJB: null,
          endTanggalFJB: null,
        },
      }),
      () => {
        this.fetchDataMainPage(
          {
            [searchData?.dropdownType?.value]: searchData?.keyword,
          },
          5,
          1
        );
      }
    );
  };

  handleClickSearch = async () => {
    const { searchData } = this.state;
    this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        page: 1,
      },
      skipNextFetch: true,
    }));

    this.fetchDataMainPage(
      {
        ...searchData,
      },
      this.state.pagination.limit,
      1
    );
  };

  handleModalFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleChangeNamCustomerOrNoPolisi = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: value,
      },
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: moment(value, "DD-MM-YYYY").format("DD-MM-YYYY"),
      },
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  getTableColumns = () => {
    return getTableConfigNOS({
      userAccess: this.state.userAccess,
      onShowDetail: this.handleShowDetail,
      onDelete: this.handleDelete,
      onPrint: this.handleShowPrint,
      dataTable: this.state.dataTable,
    });
  };

  handleCabangChange = async (name, value) => {
    const { menuAccess } = this.props;
    this.setState((prev) => ({
      ...prev,
      [name]: value,
      userAccess: getUserAccess(menuAccess, value?.value),
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handlePrintMonitoring = async () => {
    const { setError } = this.props;
    const { kodeCabang, searchData } = this.state;
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE")
        .generateExcelMonitoringFJb,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: {
        kodeCabang: kodeCabang?.value,
        startTanggalFJB: searchData?.startTanggalFJB,
        endTanggalFJB: searchData?.endTanggalFJB,
      },
    });
    this.handleTriggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `FJB_${kodeCabang?.label}.xlsx`);
    }
  };

  handleShowPrint = async (index) => {
    const { dataTable } = this.state;
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").printNotaFjb,
      setError: this.props.setError,
      menuName: "Faktur Jual Bengkel - NOS",
      args: {
        workOrderId: dataTable[index]?.nomorFJB,
      },
    });
    this.handleTriggerLoading();
    if (res.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        printVisible: true,
        PDF: URL.createObjectURL(res.data),
      }));
    }
  };

  handleHidePrint = async (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      printVisible: false,
      PDF: null,
    }));
  };

  handleShowDetail = (index, activityType) => {
    this.setState((prevValue) => ({
      ...prevValue,
      detailVisible: !prevValue.detailVisible,
      selectedData: this.state.dataTable[index],
      activityType: activityType,
    }));
  };

  handleRefresh = () => {
    this.setState(
      (prev) => ({
        ...prev,
        skipNextFetch: true,
      }),
      () => {
        const { dropdownType, keyword, ...rest } = this.state.searchData;
        let filter = {
          ...rest,
          ...(dropdownType && keyword ? { [dropdownType.value]: keyword } : {}),
        };
        if (this.state.submittedFilterData) {
          const {
            namaVarian,
            namaWarna,
            kodeVarian,
            kodeWarna,
            status,
            ...restFilter
          } = this.state.submittedFilterData;
          filter = {
            ...restFilter,
            ...(kodeVarian ? { kodeVarian: kodeVarian?.value } : {}),
            ...(kodeWarna ? { kodeWarna: kodeWarna?.value } : {}),
            ...(status ? { status: status?.value } : {}),
          };
        }
        this.fetchDataMainPage(
          removeNullFields({ ...filter }),
          this.state.pagination.limit,
          this.state.pagination.page,
        );
      },
    );
  };

  handleDelete = async (index) => {
    const { dataTable } = this.state;
    const { setError } = this.props;
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").updateStatusFJB,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: {
        id: dataTable[index].id,
        workOrderNumber: dataTable[index].workOrderId,
        status: "INACTIVE",
      },
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleRefresh();
    }
  };

  handleSubmitFilter = (payload) => {
    this.setState((prev) => ({
      ...prev,
      submittedFilterData: payload,
      searchData: {
        ...prev.searchData,
        startTanggalFJB: null,
        endTanggalFJB: null,
      },
      pagination: {
        ...prev.pagination,
        page: 1,
      },
      skipNextFetch: true,
    }));
    const { namaVarian, namaWarna, ...rest } = payload;
    this.fetchDataMainPage(
      removeNullFields({
        ...rest,
        ...(rest?.kodeCabang ? { kodeCabang: rest?.kodeCabang?.value } : {}),
        ...(rest?.kodeVarian ? { kodeVarian: rest?.kodeVarian?.value } : {}),
        ...(rest?.kodeWarna ? { kodeWarna: rest?.kodeWarna?.value } : {}),
        ...(rest?.status ? { status: rest?.status?.value } : {}),
      }),
      this.state.pagination.limit,
      1
    );
  };

  render() {
    const { menuAccess } = this.props;
    const {
      dataTable,
      pagination,
      loading,
      detailVisible,
      kodeCabang,
      cabangOptions,
      selectedData,
      activityType,
      printVisible,
      PDF,
      submittedFilterData,
      filterVisible,
      userAccess,
    } = this.state;
    return (
      <React.Fragment>
        <FakturJualBengkelSearch
          tab="NOS"
          state={this.state}
          onSubmit={this.handleClickSearch}
          onSearchKeyword={this.handleSearchKeyword}
          onShowFilter={this.handleModalFilterVisibility}
          onValueChange={this.handleValueChange}
          onChangeNamCustomerOrNoPolisi={this.handleChangeNamCustomerOrNoPolisi}
          onCabangChange={this.handleCabangChange}
          menuAccess={menuAccess}
        />
        <SimpleDataTable
          data={dataTable}
          columns={this.getTableColumns()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
        />
        <FlexView
          style={{ gap: "10px", justifyContent: "flex-end", marginTop: "20px" }}
        >
          {userAccess?.createAccess && (
            <SimpleButton
              id="btn_add_fjb_nos"
              text="Tambah Data"
              onClick={() => this.handleShowDetail(null, ACTIVITY_TYPE.CREATE)}
            />
          )}
          <SimpleButton
            id="btn_print_fjb_nos"
            onClick={() => this.handlePrintMonitoring()}
            text="Cetak"
          />
        </FlexView>
        {detailVisible && (
          <FakturJualBengkelDetail
            {...this.props}
            tab="NOS"
            activityType={activityType}
            selectedData={selectedData || null}
            cabangOptions={cabangOptions}
            kodeCabang={kodeCabang}
            visible={detailVisible}
            onRefresh={this.handleRefresh}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={() => this.handleShowDetail()}
          />
        )}
        {filterVisible && (
          <FakturJualBengkelNosFilter
            {...this.props}
            cabangOptions={this.state.cabangOptions}
            visible={filterVisible}
            submittedFilterData={submittedFilterData}
            onClickClose={this.handleModalFilterVisibility}
            onSubmit={this.handleSubmitFilter}
            onTriggerLoading={this.handleTriggerLoading}
          />
        )}
        {loading && <SimpleLoadingOverlay active={loading} />}
        {printVisible && (
          <SimpleModal
            title="Print Preview"
            visible={printVisible}
            onClickClose={() => this.handleHidePrint()}
            styles={{
              width: "100%",
            }}
            content={
              <>
                {PDF && (
                  <iframe
                    title="Nota FJB"
                    src={PDF}
                    style={{
                      border: "none",
                      width: "100%",
                      minHeight: "100vh",
                    }}
                  />
                )}
                <input
                  type="file"
                  accept=".pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file && file.type === "application/pdf") {
                      const fileReader = new FileReader();
                      fileReader.onload = () => {
                        this.onStateChange({
                          PDF: fileReader.result,
                        });
                      };

                      fileReader.readAsDataURL(file);
                    }
                  }}
                />
              </>
            }
          />
        )}
      </React.Fragment>
    );
  }
}

export default FakturJualBengkelNOS;
